module.exports = __webpack_public_path__ + "img/sea.77ae3b4f.jpg";